import React from 'react';
import {
    VertModal,
    Typography
} from '@vertem-core/vertice-ds';
import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';
import { Col, Row } from 'antd';
import WarningPaymentRulesIcon from '../Icons/warningPaymentRules';

const PaymentRulesBillModal = ({ isOpen, onClose }) => {

    const wrapperRulesText = (number) => {
        switch (number) {
            case 1:
                return "Pague apenas contas de água, luz, telefone e gás através deste serviço.";

            case 2:
                return "Pagamento disponível de segunda à sexta-feira, das 8h às 18h.";

            case 3:
                return "É permitido realizar apenas um pagamento a cada 24 horas.";

            case 4:
                return "O valor do boleto não deve ultrapassar R$ 1.000,00.";

            case 5:
                return "Só serão aceitos pagamentos realizados até 7 dias antes do vencimento.";
        }
    }

    return (
        <VertModal
            width={'40%'}
            destroyOnClose={true}
            open={isOpen}
            onCancel={() => onClose()}
            className="modal-rules-bill-payment"
        >

            <Row gutter={[16, 16]}>
                <Col
                    className='container-payment-rules-details'
                    span={24}>

                    <WarningPaymentRulesIcon />

                    <Typography.Text className='payment-rules-details-text-main'>
                        Regras de pagamento
                    </Typography.Text>
                </Col>

                <Col span={24}>

                    <Typography.Text className='payment-rules-details-text-sub'>
                        Antes de prosseguir, confira as regras para a utilização deste serviço:
                    </Typography.Text>

                </Col>

                {
                    [1, 2, 3, 4, 5].map(number => (
                        <Col span={24}>

                            <Row align={'middle'} gutter={[16, 16]}>

                                <Col>

                                    <div className='payment-rules-number-container'>
                                        <span className='payment-rules-number'>
                                            {number}
                                        </span>
                                    </div>

                                </Col>

                                <Col>

                                    <Typography.Text className='payment-rules-number-text'>
                                        {wrapperRulesText(number)}
                                    </Typography.Text>

                                </Col>

                            </Row>

                        </Col>

                    ))
                }

            </Row>

        </VertModal>
    );
};

export default PaymentRulesBillModal;
